import axios from 'axios'
import { APIS, BASEURL } from '@/API'
import { getApiErrorMessage } from '@/utils'

export default class CreateAxios {
  constructor(store) {
    this.store = store
    this.instance = axios.create({ baseURL: BASEURL, timeout: 50000 })
    this.https = {}
    this.configureInterceptors()
    this.init()
  }

  configureInterceptors() {
    this.instance.interceptors.request.use(config => {
      const token = this.store.getters.getToken
      if (token) config.headers['Auth-Token'] = token
      return config
    })

    this.instance.interceptors.response.use(
      response => {
        const payload = response.data
        if (payload?.code === 401 || response.status === 401) {
          this.handleUnauthorized()
        } else if (payload && payload.code !== 200 && Object.prototype.hasOwnProperty.call(payload, 'code')) {
          this.store.commit('setError', {
            status: true,
            message: getApiErrorMessage(payload),
            type: 'error'
          })
        } else {
          this.clearError()
        }
        return response
      },
      error => {
        const payload = error.response?.data
        if (payload?.code === 401 || error.response?.status === 401) {
          this.handleUnauthorized()
        } else {
          this.store.commit('setError', {
            status: true,
            message: getApiErrorMessage(payload, '服务器网络出现了问题，请稍后'),
            type: 'error'
          })
        }
        // 服务器已返回业务响应时，交给 Vuex action 统一处理 code/message，避免页面出现未捕获异常。
        if (error.response) return error.response
        return Promise.reject(error)
      }
    )
  }

  clearError() {
    this.store.commit('setError', { status: false, message: '' })
  }

  handleUnauthorized() {
    this.store.commit('setLoginOut')
    this.store.commit('setError', { status: true, message: '登录已失效，请重新登录', type: 'error' })
    this.store.commit('toLogin')
  }

  initParams(params, isFormData) {
    if (!isFormData) return params
    const formData = new FormData()
    Object.entries(params).forEach(([key, value]) => {
      const values = Array.isArray(value) ? value : [value]
      values.forEach(item => formData.append(key, item?.file && item?.content ? item.file : item))
    })
    return formData
  }

  request(params, isFormData, config, url, method) {
    const requestConfig = { ...config, url, method, baseURL: config.baseURL || BASEURL, timeout: config.timeout || 50000 }
    const data = this.initParams(params, isFormData)
    if (['get', 'delete'].includes(method)) requestConfig.params = data
    else requestConfig.data = data
    return this.instance.request(requestConfig)
  }

  init() {
    APIS.forEach(api => {
      this.https[api.name] = (params = {}, isFormData = false, config = {}) =>
        this.request(params, isFormData, config, api.url, api.method)
    })
    this.store.commit('setHttps', this.https)
  }
}
